import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => {
  return {
    group: {
      display: 'flex',
      alignItems: 'flex-end',
      columnGap: theme.spacing(2),
    },
    searchGroup: {
      flexGrow: 1,
      flexDirection: 'column',
      display: 'flex',
      rowGap: theme.spacing(2),
    },
  };
})